interface ToastProps {
    readonly text: string;
    readonly variant?: 'update' | 'info';
    readonly actionLabel?: string;
    readonly onAction?: () => void;
    /**
     * כפתור הסגירה **אופציונלי**.
     *
     * באנר עדכון בתפריט אינו ניתן לסגירה בכוונה: "אחר כך" שהעלים אותו לתמיד
     * השאיר משתמשים על גרסה ישנה בלי שום דרך לחזור, וזה קרה בפועל.
     */
    readonly dismissLabel?: string | undefined;
    readonly onDismiss?: (() => void) | undefined;
}

export function Toast({
    text,
    variant = 'info',
    actionLabel,
    onAction,
    dismissLabel,
    onDismiss,
}: ToastProps) {
    return (
        <div className={variant === 'update' ? 'toast toast--update' : 'toast'} role="status">
            <span className="toast__text">{text}</span>
            {actionLabel && onAction && (
                <button className="toast__action" type="button" onClick={onAction}>
                    {actionLabel}
                </button>
            )}
            {dismissLabel && onDismiss && (
                <button className="toast__dismiss" type="button" onClick={onDismiss}>
                    {dismissLabel}
                </button>
            )}
        </div>
    );
}
